import React, { useState } from 'react'
import {
  Box,
  Typography,
  Paper,
  Button,
  Checkbox,
  FormControlLabel,
  Snackbar,
  Alert,
  Divider,
  Select,
  MenuItem,
} from '@mui/material'

// Componentes personalizados
import InventarioCards from 'src/components/InventarioCards/InventarioCards'
import OptimizacionSection from 'src/components/OptimizacionSection/OptimizacionSection'
import PlanificacionTable from 'src/components/PlanificacionTable/PlanificacionTable'
import PlanificacionChart from 'src/components/PlanificacionChart/PlanificacionChart'
import ModificarPlanVentasModal from 'src/components/ModificarPlanVentasModal/ModificarPlanVentasModal'
import ComentariosModal from 'src/components/ComentariosModal/ComentariosModal'
import LlegadasModal from 'src/components/LlegadasModal/LlegadasModal'

// Hook personalizado
import { useDetalleCompra } from 'src/hooks/useDetalleCompra'

const DetalleCompra = ({ initialParams, escenarioSeleccionado = 'inicial_2025_6', tipoNegocio = 'ASAS', esSoloLectura = false }) => {
  const {
    showAlert,
    alertMessage,
    companiaSelected,
    modelos,
    loadingModelos,
    modeloSlected,
    inventarioData,
    loadingInventario,
    tablaData,
    loadingTabla,
    nivelServicio,
    mesLlegada,
    fobLlegadasUnidadesTotales,
    cargabilidad,
    mesesColumnas,
    tipoPeriodo,
    prototipos,
    segundas,
    tiposPeriodoDisponibles,
    isLlegadasModalOpen,
    setNivelServicio,
    setMesLlegada,
    setPrototipos,
    setSegundas,
    handleModeloChange,
    handleTipoPeriodoChange,
    handleOptimizarInventario,
    handleActualizarCargabilidad,
    handleCloseAlert,
    handleOpenLlegadasModal,
    handleCloseLlegadasModal,
    handleNextModelo,
    handlePreviousModelo,
    refetchTablaData,
    optimizacionTecnoSuper,
    loadingOptimizacionTecnoSuper,
    handleToggleOptimizacionTecnoSuper,
  } = useDetalleCompra(initialParams, escenarioSeleccionado, tipoNegocio)

  // Estados para los modales
  const [modalOpen, setModalOpen] = useState(false)
  const [comentariosModalOpen, setComentariosModalOpen] = useState(false)

  const handleCloseModal = () => {
    setModalOpen(false)
  }

  const handleSaveSuccess = () => {
    // Recargar los datos de la tabla después de guardar
    refetchTablaData()
  }

  const handleComentarios = () => {
    setComentariosModalOpen(true)
  }

  const handleCloseComentariosModal = () => {
    setComentariosModalOpen(false)
  }

  // Mostrar loading mientras cargan los modelos
  if (loadingModelos) {
    return (
      <Paper elevation={1} sx={{ borderRadius: 2, overflow: 'hidden', p: 3 }}>
        <Typography>Cargando modelos...</Typography>
      </Paper>
    )
  }

  // Mostrar mensaje cuando no hay modelos por filtros
  if (modelos.length === 0) {
    return (
      <Paper elevation={1} sx={{ borderRadius: 2, overflow: 'hidden', p: 3 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          No hay modelos disponibles
        </Typography>
        <Typography variant="body2" color="text.secondary">
          No se encontraron modelos que cumplan con los filtros aplicados en la pestaña de Resumen.
          Por favor, ajusta los filtros de Segmentos y Estados en Resumen para ver modelos.
        </Typography>
      </Paper>
    )
  }

  return (
    <Paper elevation={1} sx={{ borderRadius: 2, overflow: 'hidden' }}>
      {/* Información del tipo de negocio seleccionado */}
      <Box sx={{ p: 1.5 }}>
        {/* Mostrar tipo de negocio seleccionado */}
        <Box sx={{ 
          mb: 1, 
          display: 'flex', 
          flexWrap: 'wrap',
          gap: 3,
          alignItems: 'center',
          fontSize: '0.875rem',
          color: '#414142'
        }}>
          {/* <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
            <b>Tipo de Negocio:</b> {tipoNegocio}
          </Typography> */}
          <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
            <b>Compañía:</b> {companiaSelected}
          </Typography>
          <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
            <b>Escenario:</b> {escenarioSeleccionado}
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={prototipos}
                onChange={(e) => setPrototipos(e.target.checked)}
              />
            }
            label={<Typography variant="body2" sx={{ fontSize: '0.875rem' }}>Prototipos</Typography>}
            sx={{ ml: 0.5, mr: 0 }}
          />
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={segundas}
                onChange={(e) => setSegundas(e.target.checked)}
              />
            }
            label={<Typography variant="body2" sx={{ fontSize: '0.875rem' }}>Segundas</Typography>}
            sx={{ ml: 0.5, mr: 0 }}
          />
          <br />
         
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mb: 1,
            flexWrap: 'wrap',
          }}
        >
          <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
            <b>Modelo:</b>
          </Typography>

          <Button onClick={handlePreviousModelo} variant="outlined" size="small">
            ←
          </Button>

          {/* Selector de modelo */}
          <Select
            value={modeloSlected}
            onChange={handleModeloChange}
            size="small"
            sx={{ minWidth: 240 }}
            displayEmpty
          >
            <MenuItem value="">
              <em>Selecciona un modelo</em>
            </MenuItem>
            {modelos.map((modelo) => (
              <MenuItem
                key={modelo.modelo_planeacion}
                value={modelo.modelo_planeacion}
              >
                {modelo.modelo_planeacion}
              </MenuItem>
            ))}
          </Select>

          <Button onClick={handleNextModelo} variant="outlined" size="small">
            →
          </Button>

          {String(companiaSelected || '').toUpperCase() === 'ELECTRIC' && (
            <Button
              variant={optimizacionTecnoSuper ? 'contained' : 'outlined'}
              size="small"
              onClick={handleToggleOptimizacionTecnoSuper}
              disabled={esSoloLectura || loadingOptimizacionTecnoSuper}
              sx={{
                ml: { xs: 0, md: 'auto' },
                whiteSpace: 'nowrap',
                borderColor: '#4c75aa !important',
                color: optimizacionTecnoSuper ? '#fff !important' : '#4c75aa !important',
                backgroundColor: optimizacionTecnoSuper
                  ? '#4c75aa !important'
                  : 'transparent',
                '&:hover': {
                  backgroundColor: optimizacionTecnoSuper
                    ? '#3d5f8a !important'
                    : '#e3f2fd !important',
                  borderColor: '#4c75aa !important',
                },
              }}
            >
              Incluir optimización tecno super
            </Button>
          )}
        </Box>
       

        {/* Loading estado */}
        {(loadingInventario || loadingTabla) && (
          <Box sx={{ textAlign: 'center', p: 2 }}>
            <Typography>Cargando datos...</Typography>
          </Box>
        )}

        {/* Contenido principal - solo se muestra cuando hay modelo seleccionado y no está cargando */}
        {modeloSlected && inventarioData && !loadingInventario && (
          <>
            {/* Cards de inventario */}
            <InventarioCards inventarioData={inventarioData} />

            <Divider sx={{ mb: 1.5 }} />

            {/* Sección de optimización */}
            <OptimizacionSection
              nivelServicio={nivelServicio}
              setNivelServicio={setNivelServicio}
              mesLlegada={mesLlegada}
              setMesLlegada={setMesLlegada}
              cargabilidad={cargabilidad}
              disableOptimizarInventario={prototipos || segundas}
              onOptimizar={handleOptimizarInventario}
              onActualizarCargabilidad={handleActualizarCargabilidad}
              readOnly={esSoloLectura}
            />

            {/* Título del modelo */}
            {modeloSlected && (
             <p style={{
              fontSize: '16px',
              fontWeight: 'bold',
              fontFamily: 'inherit',
             }}>{modeloSlected}</p>
            )}

            {/* Tabla principal */}
            <PlanificacionTable
              tablaData={tablaData}
              mesesColumnas={mesesColumnas}
              // onSellInButtonClick={handleSellInButtonClick}
              onLlegadasButtonClick={handleOpenLlegadasModal}
              tipoPeriodo={tipoPeriodo}
              mesLlegada={mesLlegada}
              fobLlegadasUnidadesTotales={fobLlegadasUnidadesTotales}
              modeloPlaneacion={modeloSlected}
              escenario={escenarioSeleccionado}
              onDataRefresh={refetchTablaData}
              nivelServicio={nivelServicio}
              tipoNegocio={tipoNegocio}
              tiposPeriodoDisponibles={tiposPeriodoDisponibles}
              onTipoPeriodoChange={handleTipoPeriodoChange}
              metricasBiasMape={inventarioData}
              readOnly={esSoloLectura}
            />

            {/* Gráfica de Planificación */}
            <PlanificacionChart 
              tablaData={tablaData} 
              mesesColumnas={mesesColumnas}
              tipoPeriodo={tipoPeriodo}
              mesLlegada={mesLlegada}
            />

            {/* Footer con botones de acción */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mt: 2,
                borderTop: '1px solid #ddd',
                pt: 2,
              }}
            >
              <Button
                variant="outlined"
                onClick={handleComentarios}
                disabled={!modeloSlected}
                sx={{
                  borderColor: '#4c75aa !important',
                  color: '#4c75aa !important',
                  '&:hover': {
                    backgroundColor: '#e3f2fd !important',
                    borderColor: '#4c75aa !important',
                  },
                  '&:disabled': {
                    borderColor: '#ccc !important',
                    color: '#ccc !important',
                  }
                }}
              >
                Comentarios
              </Button>
            </Box>
          </>
        )}
      </Box>

      {/* Modal para modificar plan de ventas */}
      <ModificarPlanVentasModal
        open={modalOpen}
        onClose={handleCloseModal}
        mesesColumnas={mesesColumnas}
        modeloSeleccionado={modeloSlected}
        onSaveSuccess={handleSaveSuccess}
        tipoPeriodo={tipoPeriodo}
        escenario={escenarioSeleccionado}
      />

      {/* Modal de comentarios */}
      <ComentariosModal
        open={comentariosModalOpen}
        onClose={handleCloseComentariosModal}
        modeloSeleccionado={modeloSlected}
        escenario={escenarioSeleccionado}
        readOnly={esSoloLectura}
      />

      {/* Modal de llegadas */}
      <LlegadasModal
        open={isLlegadasModalOpen}
        onClose={handleCloseLlegadasModal}
        modeloPlaneacion={modeloSlected}
        tipoPeriodo={tipoPeriodo}
        escenario={escenarioSeleccionado}
        onDataUpdate={refetchTablaData}
        readOnly={esSoloLectura}
      />

      {/* Snackbar para notificaciones */}
      <Snackbar
        open={showAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseAlert}
          severity="success"
          sx={{ width: '100%' }}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
    </Paper>
  )
}

export default DetalleCompra
